var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('email-form-modal',{attrs:{"modal-id":_vm.modalId,"title":"Email Purchase Order","initial-emails":[_vm.prefilledEmail],"request":_vm.submitRequest},on:{"success":(supplyOrder) => _vm.$emit('input', supplyOrder)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }